import { FallbackProps } from 'react-error-boundary';

const ErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => {
  return (
    <div role="alert">
      <p className="text-[16px] noto-sans-jp text-textPrimary">
        エラーが発生しました:
      </p>
      <pre className="text-[14px] noto-sans-jp text-textSecondary">
        {error.message}
      </pre>
      <button className="text-primary underline" onClick={resetErrorBoundary}>
        再試行
      </button>
    </div>
  );
};

export default ErrorFallback;
